import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import ChevronRightIcon from "mdi-react/ChevronRightIcon";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const PaginationComponent = ({ initialPage, setPages, current, count }) => {
  const [currentPage, setCurrentPage] = useState(initialPage);

  let pages = [];
  const pageNumber = (page) => {
    for (let i = 0; i < page; i++) {
      pages.push(i);
    }
    return page;
  };
  pageNumber(count);
  
  return (
    <div className="pagination__wrap pagination__wrap--small">
      <Pagination className="pagination" dir="ltr">
        <PaginationItem
          className="pagination__item"
          disabled={current + 1 === 1}
        >
          <PaginationLink
            className="pagination__link pagination__link--arrow"
            type="button"
            onClick={() => setPages(current - 1)}
          >
            <ChevronLeftIcon className="pagination__link-icon" />
          </PaginationLink>
        </PaginationItem>

        {pages.map((data, index) => (
          <PaginationItem className="pagination__item" key={index}>
            <PaginationLink
              className={`pagination__link pagination__link--arrow ${
                index === current ? `pagination_selected` : ``
              }`}
              type="button"
              onClick={() => setPages(data)}
            >
              <span className="pagination__link-icon">{data + 1}</span>
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem className="pagination__item">
          <PaginationLink
            className="pagination__link pagination__link--arrow"
            type="button"
            disabled={current + 1 === count}
            onClick={() => setPages(current + 1)}
          >
            <ChevronRightIcon className="pagination__link-icon" />
          </PaginationLink>
        </PaginationItem>
      </Pagination>
    </div>
  );
};

PaginationComponent.propTypes = {
  initialPage: PropTypes.number.isRequired,
};

export default PaginationComponent;